<template>
  <el-row type="flex" justify="center">
    <el-col :sm="24" :md="14" :lg="12">
      <ra-card :header="false">
        <template slot="content">
          <el-row type="flex">
            <el-col :md="8" :lg="8">
              <div class="rd-form--section">
                <h6>Personal Information</h6>
              </div>
            </el-col>
          </el-row>
          <el-form :model="form" label-position="top" ref="form">
            <el-row type="flex" :gutter="20" class="flex-wrap">
              <el-col :md="12" :lg="12">
                <el-form-item
                  label="First Name"
                  prop="first_name"
                  :rules="validateField()"
                >
                  <el-input v-model="form.first_name" />
                </el-form-item>
              </el-col>
              <el-col :md="12" :lg="12">
                <el-form-item
                  label="Last Name"
                  prop="last_name"
                  :rules="validateField()"
                >
                  <el-input v-model="form.last_name" />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row type="flex" :gutter="20" class="flex-wrap">
              <el-col :sm="12" :md="12">
                <el-form-item label="BVN">
                  <el-input
                    v-model="form.identification_number"
                    v-only-number
                    maxlength="11"
                  />
                </el-form-item>
              </el-col>
              <el-col :sm="12" :md="12">
                <el-form-item label="Date of Birth">
                  <el-date-picker
                    class="mr-1"
                    v-model="form.dob"
                    value-format="yyyy-MM-dd"
                    placeholder="Date of Birth"
                    default-value="2004-12-31"
                    :picker-options="{
                      disabledDate: disabledDates
                    }"
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <div class="is-flex is-justify-end">
              <el-button type="primary" :loading="loading" @click="verify"
                >Update</el-button
              >
            </div>
          </el-form>
        </template>
      </ra-card>
    </el-col>
  </el-row>
</template>

<script>
import { userData } from "@/lib/utils";
import * as actions from "@/store/action-types";
import apiConstants from "@/apiConstants";

export default {
  name: "AccountProfile",
  data() {
    return {
      authData: userData(),
      loading: false,
      form: {
        first_name: "",
        last_name: "",
        identification_number: "",
        dob: ""
      }
    };
  },

  computed: {
    user() {
      return this.$store.getters.user.user;
    }
  },

  created() {
    this.form = {
      first_name: this.user.first_name,
      last_name: this.user.last_name,
      identification_number: this.user.identification_number,
      dob: this.user.dob
    };
  },

  methods: {
    disabledDates(time) {
      return time.getTime() > new Date("2004-12-31").getTime();
    },
    verify() {
      this.$refs.form.validate(async valid => {
        if (!valid) {
          this.loading = false;
          return false;
        }
        this.loading = true;
        const apiUrl = `accounts/users/${this.user.id}`;
        const { first_name, last_name, dob, identification_number } = this.form;

        let body = {
          first_name,
          last_name
        };

        if (dob) {
          body.dob = dob;
        }

        if (identification_number) {
          body.identification_number = identification_number;
          body.identification_system_id =
            apiConstants.IDENTIFICATION_SYSTEM.INDIVIDUAL;
        }

        this.$http
          .post(apiUrl, {
            body: body,
            method: "PUT"
          })
          .then(response => {
            this.loading = false;
            const resData = response.data;
            if (resData.status === "error") {
              this.handleErrors(resData);
            } else {
              this.$store.dispatch(actions.USER, {
                ...this.$store.getters.user,
                user: {
                  ...resData.data
                }
              });
              this.notification(
                "Verification",
                "Personal information verified successfully",
                "success"
              );
            }
          })
          .catch(() => {
            this.loading = false;
            this.notification("Error", "An unknown error occurred", "danger");
          });
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.rd-form--section {
  margin: 20px 0;
}
</style>
